import tw, { styled } from 'twin.macro';

export const IconWrapper = styled.span`
    > * {
        ${tw`h-3! w-3!`}
    }
`;
